<template>
    <div v-show="isOpen" v-bind="$attrs">
        <div class="content">
            <slot v-bind="this" />
        </div>
        <div class="mask" v-on:click="backdropClick()"></div>
    </div>
</template>

<script>
    const logoContext = require.context('SKYXH/assets/images/tips/', false, /\.png$/);
    import { dialogComponent } from 'BASE/plugins/dialogPlugin';
    export default {
        mixins: [dialogComponent],
        data() {
            return {
                defOptions: {
                    title: '贴心提示',
                    warningAutoHideLength: 3,
                    logoImgUrl: './img22.png',
                    cancelStr: '取 消',
                    confirmStr: '确 定',

                }
            }
        },
        computed: {
            logoUrl() {
                try {
                    let _imgurl = this.defOptions.logoImgUrl;
                    var x = logoContext(_imgurl);
                    if(this.options.logoImgUrl) {
                        _imgurl = this.options.logoImgUrl
                    }

                    return logoContext(_imgurl);
                } catch (err) {
                    return '';
                }
            }
        },
    };
</script>